import request from '@/axios/request'

// 查询讲师列表
export function pageListTeacher(query) {
    return request({
        url: '/business/web/teacher/pageList',
        method: 'get',
        params: query
    })
}

// 查询讲师详细
export function getTeacher(id) {
    return request({
        url: '/business/web/teacher/get/' + id,
        method: 'get'
    })
}

// 查询教师列表
export function listTeacher() {
    return request({
        url: '/business/web/teacher/list',
        method: 'get'
    })
}
